<div [@togglePageLoader]="loading" *ngIf="loading"  class="page-loader">
    <svg viewBox="25 25 50 50">
        <circle cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
    </svg>
    {{ 'global.pageloader' | translate }}
</div>